import { render } from "./WizardNav.vue?vue&type=template&id=69177dab"
import script from "./WizardNav.vue?vue&type=script&lang=js"
export * from "./WizardNav.vue?vue&type=script&lang=js"
script.render = render

export default script